<template>
  <div>
    <v-dialog v-model="g703_cost_plus_report" max-width="1300" persistent scrollable>
      <v-card :loading="loading">
        <v-card-title class="p-1" style="line-height:0.8">
          <v-col cols="9" style="font-size: 18px;padding:0px" class="text-center mt-1">
            <b style="color:#666666;">Invoice</b>
          </v-col>
          <!-- <v-col cols="3" class="text-right fs-12">{{report_header_name}}</v-col> -->
        </v-card-title>
        <v-divider class></v-divider>
        <v-card-text style="height: 100%;" class>
          <v-row dense class="ml-1 custom-font-for-print">
            <!-- <v-col cols="5">
              <div>
                AIA DOCUMENT G702, APPLICATION AND CERTIFICATE FOR PAYMENT, containing
                <br />Contractor's signed certification is attached.
              </div>
              <div class="pt-3">
                In tabulations below, amounts are stated to the nearest dollar.
                <br />Use Column I on Contracts where variable retainage for line items may apply.
              </div>
            </v-col>-->
            <v-col cols="8" class="text-center">
              <v-row dense class="mt-3">
                <v-col cols="4">
                  <v-row dense>
                    <v-col cols="3" style="max-width: 22%">
                      <v-img :src="company_details.logo_path" width="60"></v-img>
                    </v-col>
                    <v-col class="license-number" style="line-height: 18px">
                      <div style="font-size: 16px">{{ company_details.name }}</div>
                      <div class="ml-2" style="font-size: 12px">{{ company_details.license_number }}</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="8" class="text-center">
                  <div class="ml-2" style="font-size: 14px">
                    <b>Project: {{project_details.p_name ? project_details.p_name :''}}</b>
                    <br />
                    {{project_details.p_address_1}}{{project_details.p_address_2 ? ', '+project_details.p_address_2:''}}
                    <br />
                    {{(project_details.city)? ' '+project_details.city.city_name:''}}{{(project_details.state)? ', '+project_details.state.state_name:''}}{{project_details.p_zip? '-'+project_details.p_zip: ''}}
                  </div>
                </v-col>
                <!-- <v-col cols="4" class="text-right">
              
                </v-col>-->
              </v-row>
              <v-row dense>
                <v-col cols="6" class="text-left">
                  {{ company_details.shipping_address_line_1 }}
                  <br />
                  {{ company_details.shipping_city_details.city_name }},
                  {{ company_details.shipping_state_details.short_name }}
                  {{ company_details.shipping_zip }}
                  <br />
                  <div>
                    Tel :
                    <b>{{ company_details.phone_number }}</b>
                    <br />
                    <a
                      :href="company_details.website_link"
                      target="_blank"
                    >{{ company_details.website_link }}</a>
                    {{
                    company_details.email +
                    "@" +
                    company_details.domain_details.domain
                    }}
                  </div>
                </v-col>
                <!-- <v-col cols="6" class="text-right">
               
                </v-col>-->
              </v-row>
            </v-col>
            <v-col cols="4" class="mt-4">
              <v-row dense class="report-header">
                <v-col
                  cols="6"
                  class="text-right"
                  v-if="g703_cost_plus_change_report==false"
                >INVOICE NUMBER :</v-col>
                <v-col cols="6" class v-if="g703_cost_plus_change_report==false">
                  <v-select
                    :items="invoice_list"
                    item-text="invoice_number"
                    item-value="generated_inv_id"
                    v-model="invoice_no"
                    hide-details
                    dense
                    style="margin-top:-5px"
                    @change="getAllInvoiceData()"
                  ></v-select>
                </v-col>

                <v-col
                  cols="6"
                  class="text-right"
                  v-if="g703_cost_plus_change_report==true"
                >CHANGE ORDER:</v-col>
                <v-col cols="6" class v-if="g703_cost_plus_change_report==true">
                  <v-select
                    :items="change_order_list"
                    item-text="change_order"
                    item-value="change_order"
                    v-model="change_order_id"
                    hide-details
                    dense
                    style="margin-top:-5px"
                    @change="getAllInvoiceData()"
                  ></v-select>
                </v-col>

                <v-col cols="6" class="text-right">INVOICE DATE :</v-col>
                <v-col cols="6">
                  <b>{{application_date}}</b>
                </v-col>
                <v-col cols="6" class="text-right">PERIOD :</v-col>
                <v-col cols="6">
                  <b>{{period_to}}</b>
                </v-col>
                <v-col cols="6" class="text-right">PROJECT NO :</v-col>
                <v-col cols="6">
                  <b>{{project_no}}</b>
                </v-col>
                <!-- <v-col cols="6" class="text-right">PROJECT NAME :</v-col>
                <v-col cols="6">
                  <b>{{project_name}}</b>
                </v-col>-->
                <v-col cols="6" class="text-right">CUSTOMER NAME :</v-col>
                <v-col cols="6">
                  <b>{{customer_name}}</b>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            class="elevation-1 mt-1 rounded-0 my-transaction-table"
            :items="items"
            hide-default-footer
            mobile-breakpoint="50"
            dense
            disable-pagination
          >
            <template v-slot:body.prepend>
              <tr class="header-background white-border right-border-white">
                <td width="5%" class="text-center">A</td>
                <td width="30%" class="text-left">B</td>
                <td width="15%" class="text-right pr-9">C</td>
                <td width="15%" class="text-right pr-8">D</td>
                <td width="15%" class="text-right pr-8">E</td>
                <td width="15%" class="text-right pr-8">F</td>
              </tr>
              <tr class="header-background right-border-white">
                <td width="5%" class="text-center">
                  Item
                  <br />No.
                </td>
                <td width="30%" class="text-left">Description of work</td>
                <td width="15%" class="text-right">
                  <span class="mr-3">Current</span>
                  <br />Amt. Spent
                </td>
                <td width="15%" class="text-right">
                  <span class="mr-3">Previous</span>
                  <br />Invoice Amt.
                </td>
                <td width="15%" class="text-right">
                  <span class="mr-5">Current</span>
                  <br />Invoice Amt.
                </td>
                <td width="15%" class="text-right">
                  <span class="mr-7">Total</span>
                  <br />Invoice Amt.
                </td>
              </tr>
            </template>
            <template v-slot:item="{ item, index}">
              <tr class="right-border-grey">
                <td width="10%" style="text-align:center;">{{index+1}}</td>
                <td width="30%" style="text-align:left;">{{item.group_name}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.total_group_amount < 0 ? 'error--text' : (item.total_group_amount == 0  ?  ''  :  'primary--text')"
                >{{item.total_group_amount!= 0 ? '$'+getAmountFormat(item.total_group_amount): ''}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.previous_group_amount < 0 ? 'error--text' : (item.previous_group_amount == 0  ?  ''  :  'primary--text')"
                >{{item.previous_group_amount!= 0 ? '$'+getAmountFormat(item.previous_group_amount): ''}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.final_group_amount < 0 ? 'error--text' : (item.final_group_amount == 0  ?  ''  :  'primary--text')"
                >{{item.final_group_amount!= 0 ? '$'+getAmountFormat(item.final_group_amount) : ''}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="item.last_group_amount < 0 ? 'error--text' : (item.last_group_amount == 0  ?  ''  :  'primary--text')"
                >{{item.last_group_amount != 0 ? '$'+getAmountFormat(item.last_group_amount): ''}}</td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="grey-lighten-background right-border-grey">
                <td width="5%"></td>
                <td width="30%" style="text-align:left;">
                  <b>Total</b>
                </td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="total_amt < 0 ? 'error--text' : '' "
                >{{ total_amt!=0 ? '$' +getAmountFormat(total_amt) : ''}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="previous_amt < 0 ? 'error--text' : '' "
                >{{ previous_amt!=0 ? '$' +getAmountFormat(previous_amt) : ''}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="final_amt < 0 ? 'error--text' : '' "
                >{{ final_amt !=0 ? '$' + getAmountFormat(final_amt) : ''}}</td>
                <td
                  width="15%"
                  style="text-align:right;"
                  :class="last_amt < 0 ? 'error--text' : '' "
                >{{last_amt !=0 ? '$' + getAmountFormat(last_amt) : ''}}</td>
              </tr>
              <tr class="right-border-grey">
                <td width="5%"></td>
                <td colspan="3" width="5%" style="text-align:left;">
                  <b>Payment Received against this Invoice</b>
                </td>
                <td
                  width="20%"
                  style="text-align:right;"
                  :class="sales_income_for_invoice < 0 ? 'error--text' : '' "
                >${{getAmountFormat(sales_income_for_invoice)}}</td>
                <td></td>
              </tr>
              <tr class="grey-lighten-background right-border-grey">
                <td width="5%"></td>
                <td colspan="3" width="5%" style="text-align:left;">
                  <b>{{0 > Balance_due_for_this_invoice ? "Customer Credit" : "Balance Due"}} for this Invoice</b>
                </td>
                <td
                  width="20%"
                  style="text-align:right;"
                  :class="Balance_due_for_this_invoice < 0 ? 'error--text' : '' "
                >${{getAmountFormat(Balance_due_for_this_invoice)}}</td>
                <td></td>
              </tr>
              <!-- <tr class="text-center">
                <td colspan="6">Summary</td>
              </tr>
              <tr>
                 <td>Total Amount invoice Amount for this Project </td>
                 <td>Total Payment Received for this project </td>
                 <td>Balance Due/Customer Credit for this Project </td>
              </tr>-->
            </template>
          </v-data-table>

          <div>
            <v-row dense class="blue lighten-4 mt-5 text-center" style="font-size: 17px;">
              <v-col cols="12">
                <span class="pl-2">
                  <b>Project Summary</b>
                </span>
              </v-col>
            </v-row>
          </div>

          <div>
            <v-row dense class="grey lighten-4 mt-2" style="font-size: 17px;">
              <v-col cols="4" width="33%">
                <span class="pl-2">
                  Total Invoice Amount:
                  <b>${{getAmountFormat(total_invoice_amt_for_project)}}</b>
                </span>
              </v-col>
              <v-col cols="4" width="33%">
                <span class="pl-2">
                  Total Payment Received:
                  <b>${{sales_income_for_project}}</b>
                </span>
              </v-col>
              <v-col cols="4" width="33%">
                <span class="pl-2">
                  {{0 > Balance_due_for_this_project ? "Customer Credit" : "Balance Due"}}:
                  <b>${{Balance_due_for_this_project}}</b>
                </span>
              </v-col>
            </v-row>
          </div>
          <!-- <v-row dense class="ml-1 mt-2 custom-font-for-print report-header2">
            <v-col
              cols="12"
            >AIA DOCUMENT G703 - APPLICATION AND CERTIFICATE FOR PAYMENT - MAY 1983 EDITION - AIA C 1983</v-col>
            <v-col
              cols="12"
            >THE AMERICAN INSTITUTE OF ARCHITECTS, 1735 NEW YORK AVENUE, N.W., WASHINGTON, D.C., 20006</v-col>
          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="loading=true;generateReport('whole_page',true); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
          <v-btn
            :loading="loading"
            @click="generateReport(false); is_send_report = false; preview_pdf_dialog = true;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Sign Online
          </v-btn>
          <v-btn
            @click="preview_pdf_dialog = true; is_send_report = true; generateReport(false);"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-send</v-icon>Send for Signature
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? email_dialog = true : signature_dialog = true"
            v-if="total_page == active_page"
            :loading="preview_pdf_loading"
          >Finish</v-btn>
          <v-btn
            v-else
            color="primary"
            class="text-capitalize"
            @click="is_send_report ? generateReport(false) : signature_dialog = true;"
            :loading="preview_pdf_loading"
          >Next Page</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
    <v-overlay absolute :value="loading" style="z-index: 999">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
  </div>
</template>
 <script>
import { getCompanyDetails } from "../../plugins/helper";
import Signatura from "../projects/Signatura";
import SendMailDialog from "../projects/SendMailDialog";
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      preview_pdf_loading: false,
      total_page: "",
      active_page: 0,
      user_sign_blob: [],
      customer_sign_blob: "",
      signature_dialog: false,
      loading: false,
      is_send_report: false,
      email_ids: null,
      email_id_arr: [],
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      items: [],
      company_details: getCompanyDetails(),
      preview_pdf_dialog: false,
      preview_page_link: "",
      project_data_flag: "",
      total_balance: "",
      total_completed: "",
      total_current: "",
      total_previous: "",
      total_schedule: "",
      project_name: "",
      project_no: "",
      customer_name: "",
      application_date: "",
      period_to: "",
      total_change_order: "",
      total_retainage: "",
      contract_date: "",
      sales_income_for_invoice: "",
      sales_income_for_project: "",
      Balance_due_for_this_invoice: "",
      total_invoice_amt_for_project: "",
      total_invoice_amt_for_invoice: "",
      Balance_due_for_this_project: "",
      change_order_list: [],
      total_amt: "0",
      final_amt: "0",
      previous_amt: "0",
      last_amt: "0",
      balance_due: "",
      invoice_list: [
        {
          amount: "0",
          invoice_number: "0",
          generated_inv_id: "0"
        }
      ],
      invoice_no: "0",
      change_order_id: ""
    };
  },
  props: [
    "g703_cost_plus_report",
    "project_details",
    "generate_invoice_project",
    "selectedRows",
    "invoice_id",
    "g703_cost_plus_change_report",
    "report_header_name"
  ],
  watch: {
    g703_cost_plus_report: function(value) {
      if (value) {
        if (this.invoice_id) {
          this.invoice_no = this.invoice_id;
        }
        this.getData();
      }
    },
    generate_invoice_project: function(value) {
      if (value) {
        this.getData();
      }
    },
    selectedRows: function(value) {
      this.items = this.items.filter(item => {
        item.current_period = 0;
        return item;
      });
      this.items = this.items.filter(item2 => {
        value.filter(item => {
          if (item2.invoice_group_id == item.invoice_group_id) {
            item2.current_period =
              parseFloat(item2.current_period) + parseFloat(item.rev_amount);
          }
        });
        return item2;
      });
    }
  },
  computed: {
    user_name() {
      return localStorage.getItem("user_name");
    }
  },
  components: {
    Signatura,
    SendMailDialog
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getAmountFormat(value) {
      if (value) {
        return value.toString().replace("-", "");
      } else {
        return 0;
      }
    },
    getData() {
      if (this.project_details.project_work == "remodeling") {
        this.project_data_flag = 2;
      } else if (this.project_details.project_work == "new_construction") {
        this.project_data_flag = 1;
      } else if (this.project_details.project_work == "project_management") {
        this.project_data_flag = 4;
      }
      this.preview_page_link = "";
      this.active_page = 0;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      // this.getReportDetails();
      if (this.g703_change_report) {
        this.getChangeOrderList();
      } else {
        this.getInvoiceList();
      }
      this.getTotalPage();
    },

    sendMail(variable) {
      this.email_id_arr = variable;
      this.sendSalesInvoiceReport();
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob.push({
          page: this.active_page,
          sign_blob: variable.user_sign_blob
        });
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids =
            this.project_details.customer.email +
            "@" +
            this.project_details.customer.email_domain.domain;
        } else {
          this.generateReport(false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.generateReport(true);
        } else {
          this.generateReport(false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    closePopup() {
      this.$emit("updateValue");
      this.invoice_list = [
        {
          amount: "0",
          invoice_number: "0",
          generated_inv_id: "0"
        }
      ];
      this.invoice_no = "0";
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "g_703");
      formData.append("report_header_name", this.report_header_name);
      formData.append("p_type", "cost_plus");
      this.loading = true;
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          // this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    generateReport(is_past_page, direct_print = false) {
      this.preview_pdf_loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      // let url = 'flag=save&project_id='+this.project_details.project_id+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id+'&sign='+this.sign_blob;
      var formData = new FormData();

      if (is_past_page) {
        if (this.user_sign_blob) {
          for (let key in this.user_sign_blob) {
            formData.append(
              `user_sign_blob[${this.user_sign_blob[key].page}]`,
              this.user_sign_blob[key].sign_blob
            );
          }
        }
        if (this.customer_sign_blob) {
          formData.append(`customer_sign_blob`, this.customer_sign_blob);
        }
        formData.append("generate_pdf_flag", "whole_page");
      } else {
        formData.append("generate_pdf_flag", "single_page");
      }
      formData.append("flag", "save");
      formData.append("project_id", this.project_details.project_id);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("project_data_flag", this.project_data_flag);
      formData.append("report_name", "g_703");
      formData.append("report_header_name", this.report_header_name);
      formData.append("direct_print", direct_print);
      formData.append("generate_invoice_id", this.invoice_no);
      formData.append("g703_change_report", this.g703_change_report);
      formData.append("g703_change_order_id", this.change_order_id);
      formData.append("p_type", "cost_plus");
      axios
        .post("generate_report_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (is_past_page) {
            if (response.data.status) {
              if (direct_print) {
                this.loading = false;
                var File_url = response.data.file_url;
                window.open(File_url, "Download");
              } else {
                this.setAlert({
                  show: true,
                  variant: "primary",
                  message: response.data.message,
                  dismissCountDown: 0
                });
                this.closePopup();
              }
              this.preview_pdf_dialog = false;
            }
          } else {
            this.preview_pdf_loading = false;
            this.preview_page_link = response.data.preview_page_link;
          }
          this.preview_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });
    },
    sendSalesInvoiceReport() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = {
        flag: "mail",
        project_id: this.project_details.project_id,
        user_name: localStorage.getItem("user_id"),
        company_id: company_data.company_id,
        active_page: this.active_page,
        total_page: this.total_page,
        email_id_arr: this.email_id_arr,
        email_ids: this.email_ids,
        generate_pdf_flag: "whole_page",
        project_data_flag: this.project_data_flag,
        report_name: "g_703"
      };
      if (this.user_sign_blob) {
        data.user_sign_blob = this.user_sign_blob;
      }
      if (this.customer_sign_blob) {
        data.customer_sign_blob = this.customer_sign_blob;
      }

      this.send_pdf_loading = true;
      axios
        .post("generate_report_pdf", data)
        .then(response => {
          this.email_ids_error = null;
          if (response.data.status) {
            this.email_dialog = false;
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            this.preview_pdf_dialog = false;
            this.closePopup();
          } else {
            this.email_ids_error = response.data.errors["email_ids"];
          }
          this.send_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.send_pdf_loading = false;
        });
    },
    getReportDetails() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_item_group?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_amt = response_data.total_amt;
          _self.loading = false;
          console.log("_self.items", _self.items);
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getAllInvoiceData() {
      let _self = this;
      let invoice_no = _self.invoice_no;
      _self.loading = true;
      axios
        .get(
          "get_all_invoice_detail?project_id=" +
            this.project_details.project_id +
            "&project_data_flag=" +
            this.project_data_flag +
            "&generate_invoice_id=" +
            invoice_no +
            "&g703_change_report=" +
            this.g703_change_report +
            "&g703_change_order_id=" +
            this.change_order_id +
            "&p_type=cost_plus"
        )
        .then(response => {
          let response_data = response.data;
          _self.items = response_data.data;
          _self.total_amt = response_data.total_amt;
          _self.previous_amt = response_data.previous_amt;
          _self.final_amt = response_data.final_amt;
          _self.last_amt = response_data.last_amt;
          _self.total_balance = response_data.total_balance;
          _self.total_completed = response_data.total_completed;
          _self.total_current = response_data.total_current;
          _self.total_previous = response_data.total_previous;
          _self.total_schedule = response_data.total_schedule;
          _self.project_name = response_data.project_name;
          _self.project_no = response_data.project_no;
          _self.customer_name = response_data.customer_name;
          _self.application_date = response_data.application_date;
          _self.period_to = response_data.period_to;
          _self.total_retainage = response_data.total_retainage;
          _self.contract_date = response_data.contract_date;
          _self.sales_income_for_invoice =
            response_data.sales_income_for_invoice;
          _self.sales_income_for_project =
            response_data.sales_income_for_project;
          _self.Balance_due_for_this_invoice =
            response_data.Balance_due_for_this_invoice;
          _self.total_invoice_amt_for_project =
            response_data.total_invoice_amt_for_project;
          _self.total_invoice_amt_for_invoice =
            response_data.total_invoice_amt_for_invoice;
          _self.Balance_due_for_this_project =
            response_data.Balance_due_for_this_project;
          setTimeout(() => {
            _self.loading = false;
          }, 1000);
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getInvoiceList() {
      let _self = this;
      axios
        .get(
          "get_project_invoice_list?project_id=" +
            this.project_details.project_id
        )
        .then(response => {
          let response_data = response.data;
          response_data.invoice_list.map(function(item) {
            _self.invoice_list.unshift(item);
          });
          if (_self.invoice_id) {
            _self.invoice_no = _self.invoice_id ? _self.invoice_id : "0";
          } else {
            _self.invoice_no = response_data.last_invoice
              ? response_data.last_invoice
              : "0";
          }

          _self.getAllInvoiceData();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getChangeOrderList() {
      let _self = this;
      axios
        .get(
          "get_project_change_order_list?project_id=" +
            this.project_details.project_id +
            "&get_all=true"
        )
        .then(response => {
          let response_data = response.data;
          response_data.change_order_list.map(function(item, index) {
            if (index == 0) {
              _self.change_order_id = item.change_order;
            }
            _self.change_order_list.push(item);
          });
          _self.getAllInvoiceData();
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    }
  },
  created: function() {},
  mounted: function() {
    this.invoice_list = [
      {
        amount: "0",
        invoice_number: "0",
        generated_inv_id: "0"
      }
    ];
    this.change_order_list = [];
    // this.$refs.userSignaturePad.openSignaturePad();
    // this.$refs.customerSignaturePad.openSignaturePad();
  }
};
</script>
 
 <style>
.sales-invoice-report p {
  margin-bottom: 0px;
}
</style>